import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import toursData from '../data/tours.json';
import './TripsSection.css';

function TripsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);

  // Select specific tours from the JSON data - get more tours for sliding
  const trips = Object.values(toursData.tours)
    .filter(tour => 
      tour.category === '   ' || 
      tour.category === 'Mid-Range'
    )
    .slice(0, 9) // Get more tours for carousel
    .map(tour => ({
      id: tour.id,
      name: tour.name,
      image: tour.image,
      location: 'Serengeti', // Default location, can be modified if location is in JSON
      duration: `${tour.duration}`,
      bestTime: 'June-October', // Default best time, can be modified if in JSON
      description: tour.description,
      price: parseInt(String(tour.price).replace(/,/g, '')) || parseInt(tour.price)
    }));

  // Handle responsive slides
  useEffect(() => {
    const updateSlidesToShow = () => {
      if (window.innerWidth >= 1200) {
        setSlidesToShow(3);
      } else if (window.innerWidth >= 768) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(1);
      }
    };

    updateSlidesToShow();
    window.addEventListener('resize', updateSlidesToShow);
    return () => window.removeEventListener('resize', updateSlidesToShow);
  }, []);

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const maxIndex = Math.max(0, trips.length - slidesToShow);
        
        if (prevIndex >= maxIndex) {
          return 0; // Reset to start
        }
        return prevIndex + 1;
      });
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(interval);
  }, [trips.length, slidesToShow]);

  const maxIndex = Math.max(0, trips.length - slidesToShow);
  const translateX = -(currentIndex * (100 / slidesToShow));

  return (
    <section className="trips-section">
      <div className="trips-container">
        <h2 className="trips-title">Our Tanzania Trips</h2>
        <p className="trips-subtitle">
          Discover unforgettable safari experiences tailored to your adventure
        </p>

        <div className="trips-carousel-wrapper">
          <div 
            className="trips-carousel"
            style={{
              transform: `translateX(${translateX}%)`
            }}
          >
            {trips.map((trip) => (
              <div key={trip.id} className="trip-card">
                <div className="trip-category-tag">Wildlife Safaris</div>
                
                <div className="trip-image-container">
                  <img 
                    src={trip.image} 
                    alt={trip.name} 
                    className="trip-image"
                  />
                </div>
                
                <div className="trip-content">
                  <h3 className="trip-name">{trip.name}</h3>
                  
                  <div className="trip-details">
                    <div className="trip-detail">
                      <i className="icon-clock">⏱</i>
                      <span>{trip.duration}</span>
                    </div>
                    <div className="trip-detail">
                      <i className="icon-calendar">📅</i>
                      <span>Best: {trip.bestTime}</span>
                    </div>
                    <div className="trip-detail">
                      <i className="icon-map-marker">📍</i>
                      <span>{trip.location}</span>
                    </div>
                  </div>
                  
                  <p className="trip-description">
                    {trip.description}
                  </p>
                  
                  <div className="trip-footer">
                    <span className="trip-price">${trip.price.toLocaleString()}</span>
                    <Link 
                      to={`/trips/${trip.id}`} 
                      className="trip-btn"
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Carousel indicators */}
        <div className="trips-carousel-dots">
          {Array.from({ length: maxIndex + 1 }).map((_, index) => (
            <button
              key={index}
              className={`trips-carousel-dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        <div className="trips-cta">
          <Link to="/trips" className="btn">View All Tours</Link>
        </div>
      </div>
    </section>
  );
}

export default TripsSection;
